// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d2adf2ee","453":"bfa9994f","732":"0b2749f5"}[chunkId] + ".chunk.js";
};